var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg88(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "48px",
    height: "48px",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st4{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.93,8.56l6.06,6.24l5.6-5.48l-6.3-6.3c0,0-0.29-1.4,1.11-1.34l6.41,6.56c0,0,1.22-1.08,2.57-0.55l3.85,3.73 c0,0,1.17,2.33-1.17,3.67l4.49,4.64c0,0,0.35,0.49-0.47,1.36l-4.9,4.84c0,0-0.58,0.12-1.05-0.47l-4.32-4.26 c0,0-1.57,2.3-3.44,1.33l-3.67-3.61c0,0-0.7-2.06,0.29-3.09L2.7,9.55C2.7,9.55,2.53,7.98,3.93,8.56z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.16,39.02l-6.19-6.37l-5.71,5.59l6.43,6.43c0,0,0.3,1.43-1.13,1.37l-6.54-6.69c0,0-1.25,1.1-2.62,0.56l-3.93-3.81 c0,0-1.19-2.38,1.19-3.75l-4.58-4.74c0,0-0.36-0.5,0.48-1.39l5-4.94c0,0,0.59-0.12,1.07,0.48l4.4,4.34c0,0,1.61-2.35,3.51-1.35 l3.75,3.68c0,0,0.71,2.1-0.3,3.16L46.41,38C46.41,38,46.59,39.61,45.16,39.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.85,16.88l4.9-4.87c0,0,1.81-0.7,1.34,1.11l-5.25,5.42C13.84,18.54,12.03,18.66,12.85,16.88z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M29.86,33.39l4.9-4.87c0,0,1.81-0.7,1.34,1.11l-5.25,5.42C30.85,35.04,29.05,35.17,29.86,33.39z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.54,26.82H11.4c-0.42,0-0.77-0.35-0.77-0.77v-0.27c0-0.42,0.35-0.77,0.77-0.77h2.13c0.42,0,0.77,0.35,0.77,0.77v0.27 C14.31,26.47,13.96,26.82,13.54,26.82z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.32,32.74l0.1-2.13c0.02-0.42,0.38-0.75,0.81-0.73l0.27,0.01c0.42,0.02,0.75,0.38,0.73,0.81l-0.1,2.13 c-0.02,0.42-0.38,0.75-0.81,0.73l-0.27-0.01C17.63,33.52,17.3,33.16,17.32,32.74z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.71,29.85l-1.6,1.41c-0.32,0.28-0.81,0.25-1.09-0.07l-0.18-0.2c-0.28-0.32-0.25-0.81,0.07-1.09l1.6-1.41 c0.32-0.28,0.81-0.25,1.09,0.07l0.18,0.2C16.05,29.08,16.02,29.57,15.71,29.85z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.53,10.8v2.13c0,0.42-0.35,0.77-0.77,0.77h-0.27c-0.42,0-0.77-0.35-0.77-0.77V10.8c0-0.42,0.35-0.77,0.77-0.77h0.27 C27.19,10.03,27.53,10.38,27.53,10.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.48,16.68l2.13,0.1c0.42,0.02,0.75,0.38,0.73,0.81l-0.01,0.27c-0.02,0.42-0.38,0.75-0.81,0.73l-2.13-0.1 c-0.42-0.02-0.75-0.38-0.73-0.81l0.01-0.27C30.7,16.99,31.06,16.66,31.48,16.68z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.29,13.33l-1.6,1.41c-0.32,0.28-0.81,0.25-1.09-0.07l-0.18-0.2c-0.28-0.32-0.25-0.81,0.07-1.09l1.6-1.41 c0.32-0.28,0.81-0.25,1.09,0.07l0.18,0.2C32.64,12.56,32.61,13.05,32.29,13.33z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg88);
export default __webpack_public_path__ + "static/media/88.6694e01aa1c8d407342deab8c3bc31c2.svg";
export { ForwardRef as ReactComponent };